export const VOICE_ENABLED_STORAGE_KEY = "fintheon:voice-assistant-enabled:v1";
export const VOICE_REPLY_AUDIO_STORAGE_KEY =
  "fintheon:voice-reply-audio-enabled:v1";
export const VOICE_CONVERSATION_STORAGE_KEY =
  "fintheon:voice-conversation:harper:v1";
export const MIC_DEVICE_STORAGE_KEY = "fintheon:voice-mic-device:v1";

export function safeLocalStorageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage can be blocked in private or embedded contexts.
  }
}
